/* eslint-disable jsx-a11y/anchor-is-valid */
import { ReactNode } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import useHasRole from '~/hooks/has-role.hook';
import Icon from './icon.component';

interface SidebarNavigationItemProps {
  link: string;
  isActive?: boolean;
  icon?: string;
  isIconSolid?: boolean;
  role?: string | Array<string>;
  children: ReactNode;
}

const SidebarNavigationItem = ({
  children,
  link,
  isActive,
  icon,
  isIconSolid,
  role,
}: SidebarNavigationItemProps) => {
  const { hasRole } = useHasRole({ name: role });
  if (role && !hasRole) return null;

  return (
    <Link href={link}>
      <a
        className={classNames(
          {
            'bg-main text-white': isActive,
            'text-white bg-main-900 hover:bg-main-800': !isActive,
          },
          'group flex items-center px-2 py-2 text-base font-medium rounded-md no-underline',
        )}
      >
        {icon && <Icon isSolid={isIconSolid} name={icon} className="mr-2" />}
        {children}
      </a>
    </Link>
  );
};

export default SidebarNavigationItem;
